import { httpService } from './api/http';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const CANONICAL_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

const VENUE_SERVICE_API_BASE = resolveGatewayBackedServiceBaseUrl(
    process.env.REACT_APP_VENUE_SERVICE_URL,
);

const VENUE_ADMIN_REVIEW_ENDPOINT = `${VENUE_SERVICE_API_BASE}/api/venues/v1/admin/review/venues`;
const MAX_REVIEW_OFFSET = 100000;

function requireCanonicalVenueObjectId(objectId) {
    if (typeof objectId !== 'string' || !CANONICAL_UUID_REGEX.test(objectId.trim())) {
        throw new Error('venue objectId must be a canonical UUID');
    }
    return objectId.trim();
}

function normalizeReviewPagination(options = {}) {
    const limit = Number.isFinite(options.limit) ? Math.floor(options.limit) : 50;
    const offset = Number.isFinite(options.offset) ? Math.floor(options.offset) : 0;
    return {
        limit: Math.min(Math.max(limit, 1), 200),
        offset: Math.min(Math.max(offset, 0), MAX_REVIEW_OFFSET),
    };
}

function appendReviewPagination(endpoint, options = {}) {
    const { limit, offset } = normalizeReviewPagination(options);
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    return `${endpoint}?${params.toString()}`;
}

async function fetchVenueReviewItems(options = {}) {
    return httpService.get(appendReviewPagination(VENUE_ADMIN_REVIEW_ENDPOINT, options), options);
}

async function verifyVenueReviewItem(objectId, payload = {}, options = {}) {
    const normalizedObjectId = requireCanonicalVenueObjectId(objectId);
    const request = {};
    if (typeof payload.notes === 'string' && payload.notes.trim()) {
        request.notes = payload.notes.trim().slice(0, 1000);
    }
    return httpService.post(
        `${VENUE_ADMIN_REVIEW_ENDPOINT}/${encodeURIComponent(normalizedObjectId)}/verify`,
        request,
        options,
    );
}

export const venueAdminService = Object.freeze({
    endpoints: Object.freeze({
        VENUE_ADMIN_REVIEW: VENUE_ADMIN_REVIEW_ENDPOINT,
    }),
    fetchVenueReviewItems,
    verifyVenueReviewItem,
});
